import "./App.css";
import React from "react";
import Dictionary from "./Dictionary";
import "bootstrap/dist/css/bootstrap.css";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <Dictionary />
    </div>
  );
}

export default App;
